var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "bottom-1 flex justify-center items-center",
      class: _vm.classes,
    },
    [
      _vm.rating
        ? _c("RatingStars", {
            staticClass: "relative",
            attrs: {
              value: _vm.rating,
              starSize: 15,
              increment: 0.1,
              readOnly: "",
            },
          })
        : _vm._e(),
      !_vm.rating
        ? _c(
            "p",
            {
              staticClass:
                "flex justify-center text-default-grey text-sm font-medium h-7",
            },
            [_vm._v("n/a")]
          )
        : _vm._e(),
      _vm.rating
        ? _c("p", { staticClass: "text-gray-new customTextStyle mt-1.5" }, [
            _vm._v("(" + _vm._s(_vm.ratingTotal.aggregate.count) + ")"),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }